import { ProductManagerEnv } from '@/config';
import { useProcurementStore } from '@/zustand';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button, Tooltip, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { InitialAddProps } from 'src/logic/models/catalogue/PrivateItem';
import { sm } from 'src/site-map';

type IProps = InitialAddProps;

const AddNewPrivateItemLink = (props: IProps) => {
  const router = useRouter();

  const isPurchaseOrderEnvironment = useProcurementStore(state => {
    const env = state.productFormManagerProperties.data?.environment?.type;
    return env === ProductManagerEnv.purchase_order || env === ProductManagerEnv.edit_po_from_scratch;
  });
  const isDisabled = isPurchaseOrderEnvironment;

  const link = React.useMemo(() => {
    const queryString = new URLSearchParams(props).toString();
    return queryString ? `${sm.catalogue.products.add.url}?${queryString}` : sm.catalogue.products.add.url;
  }, [props]);

  const isAddProductPage = router.pathname === '/catalogue/products/add';

  if (isAddProductPage) {
    return null;
  }
  return (
    <Typography lineHeight={1} variant='subtitle2' fontWeight={500} color={'text.third'}>
      Can’t find your product / service?{' '}
      <Tooltip
        title={isDisabled ? 'You cannot add new products in PO environment.' : ''}
        disableHoverListener={!isDisabled}
        arrow
      >
        <span>
          <Button
            sx={{ fontWeight: 700 }}
            startIcon={
              <InfoOutlinedIcon
                sx={{ fontSize: 'sm', color: 'primary.main', mr: -0.5, opacity: isDisabled ? 0.5 : 1 }}
              />
            }
            disabled={isDisabled}
          >
            <Link href={link}>
              <Typography
                lineHeight={1}
                fontWeight={700}
                fontSize={'12px'}
                color='primary'
                sx={{ opacity: isDisabled ? 0.5 : 1 }}
              >
                Add New
              </Typography>
            </Link>
          </Button>
        </span>
      </Tooltip>
    </Typography>
  );
};

export default AddNewPrivateItemLink;
